import { Plan } from '../models/plan';

export function getTimeFrameForPlan(plan: Plan) {
  return `(${plan.startDate ? plan.startDate.split('T')[0] : ''} - ${plan.endDate ? plan.endDate.split('T')[0] : ''})`;
}
